import Fingerprint2 from "fingerprintjs2";
import Cookies from "js-cookie";
import { v4 as uuid } from "uuid";

import {
  APP_MEMBER_KEY,
  COOKIE,
  XDEVICE_APP_TIMEOUT,
  XUIID_TIMEOUT,
} from "@/config/constants";
import { encryptDataNetwork } from "@/utils/encryptor";
import { LatLngTuple } from "leaflet";
import moment from "moment";
export const getRandomColor = () => {
  // const letters = "0123456789ABCDEF";
  // let color = "#";
  // for (let i = 0; i < 6; i++) {
  //   color += letters[Math.floor(Math.random() * 16)];
  // }
  return "#333";
};

type LatLng = {
  latitude: number;
  longitude: number;
};

export function getIndonesianGreeting(date: Date = new Date()): string {
  const hour = date.getHours();

  if (hour >= 4 && hour < 10) {
    return "Selamat pagi";
  } else if (hour >= 10 && hour < 15) {
    return "Selamat siang";
  } else if (hour >= 15 && hour < 18) {
    return "Selamat sore";
  } else {
    return "Selamat malam";
  }
}
export const getMonthRange = (month: string) => {
  const start = moment(month, "YYYY-MM").startOf("month").format("YYYY-MM-DD");
  const end = moment(month, "YYYY-MM").endOf("month").format("YYYY-MM-DD");
  return { start, end };
};

export function toIndonesianOrdinal(num: number): string {
  const ordinals = [
    "",
    "pertama",
    "kedua",
    "ketiga",
    "keempat",
    "kelima",
    "keenam",
    "ketujuh",
    "kedelapan",
    "kesembilan",
    "kesepuluh",
  ];

  if (num >= 1 && num <= 10) {
    return ordinals[num];
  }

  return `ke-${num}`;
}
// Haversine formula
export function haversineDistance(coord1: LatLng, coord2: LatLng): string {
  try {
    const toRad = (value: number) => (value * Math.PI) / 180;

    const R = 6371; // Radius of Earth in km
    const dLat = toRad(coord2.latitude - coord1.latitude);
    const dLon = toRad(coord2.longitude - coord1.longitude);

    const lat1 = toRad(coord1.latitude);
    const lat2 = toRad(coord2.latitude);

    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    return (R * c)?.toFixed(2); // Distance in kilometers
  } catch (error) {
    return "-";
  }
}

export function getClosestMarker(center: LatLngTuple, markers: LatLngTuple[]) {
  let minDistance = Infinity;
  let closestMarker = null;

  markers.forEach((marker) => {
    const distance = Math.sqrt(
      Math.pow(center[0] - marker[0], 2) + Math.pow(center[1] - marker[1], 2)
    );
    if (distance < minDistance) {
      minDistance = distance;
      closestMarker = marker;
    }
  });

  return closestMarker;
}
export function getTimeDiff(from: string | Date, to: string | Date) {
  const start = new Date(from);
  const end = new Date(to);
  const diffMs = Math.abs(end.getTime() - start.getTime());

  const totalSeconds = Math.floor(diffMs / 1000);
  const days = Math.floor(totalSeconds / (3600 * 24));
  const hours = Math.floor((totalSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds };
}

type FetchOptions = RequestInit & {
  headers?: Record<string, string>;
};
export const getPlatformDeviceType = (userAgent: string) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(userAgent);
  return isMobile ? "web_mobile" : "web_desktop";
};

export const scrollToTarget = (id: string) => {
  const element = document.getElementById(id.replaceAll("#", ""));
  if (element) {
    const offset = 60; // Adjust this value as needed
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top: elementPosition - offset, behavior: "smooth" });
  }
};

export function getOperatingSystem() {
  const userAgent = navigator.userAgent;

  if (userAgent.indexOf("Win") !== -1) {
    return "Windows";
  } else if (userAgent.indexOf("Mac") !== -1) {
    return "MacOS";
  } else if (userAgent.indexOf("Linux") !== -1) {
    return "Linux";
  } else if (userAgent.indexOf("Android") !== -1) {
    return "Android";
  } else if (userAgent.indexOf("iOS") !== -1) {
    return "iOS";
  } else {
    return "Unknown";
  }
}

export const generateAvatar = (name?: string) => {
  const initials = name!
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase())
    .join("");

  const bgColor = getRandomColor();

  return { initials, bgColor };
};

export const getFilePreviews = (files: FileList | null): string[] => {
  if (!files) return [];

  try {
    const previews = Array.from(files).map((file) => URL.createObjectURL(file));

    // Cleanup: Revoke previous URLs when component unmounts
    return previews;
  } catch (error) {
    console.log(error);
    return [];
  }
};
export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
};

export function fetchToCurlPretty(
  url: string,
  options: FetchOptions = {}
): void {
  const curlParts: string[] = [`curl --location '${url}'`];

  // Method
  const method = options.method ?? "GET";
  if (method !== "GET") {
    curlParts.push(`--request ${method}`);
  }

  // Headers
  if (options.headers) {
    for (const [key, value] of Object.entries(options.headers)) {
      curlParts.push(`--header '${key}: ${value}'`);
    }
  }

  // Body
  if (options.body) {
    curlParts.push(`--data-raw '${options.body}'`);
  }

  console.log(curlParts.join(" \\\n"));
}

export const getBasicToken = () => {
  const username = process.env.NEXT_PUBLIC_BASIC_USER_NAME;
  const password = process.env.NEXT_PUBLIC_BASIC_PASSWORD;
  const basicCredential = btoa(`${username}:${password}`);
  const basic_auth = `Basic ${basicCredential}`;
  return basic_auth;
};
export const revokeFilePreviews = (urls: string[]) => {
  urls.forEach((url) => URL.revokeObjectURL(url));
};

export const removeBase64String = (dataUrl: string) => dataUrl.split(",")[1]; // Result: "data:image/png;base64"
export const formattedNumber = (number: number) => {
  const formatted = new Intl.NumberFormat("id-ID").format(number);
  return formatted !== "NaN" ? formatted : 0;
};

export const convertFileToBase64 = async (
  file: File,
  maxImageSizeKB = 250,
  maxWidth = 800
): Promise<{ base64: string; sizeKB: number }> => {
  const isImage = file.type.startsWith("image/");

  if (isImage) {
    // Compress images before converting to base64
    return compressImageToMaxSize(file, maxImageSizeKB, maxWidth);
  } else {
    // Allow all other document types (e.g. PDF, Word, Excel, etc.)
    const base64 = await readFileAsBase64(file);
    return {
      base64,
      sizeKB: Math.round(base64.length / 1024),
    };
  }
};

const readFileAsBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

const compressImageToMaxSize = async (
  file: File,
  maxSizeKB: number,
  maxWidth: number
): Promise<{ base64: string; sizeKB: number }> => {
  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = reader.result as string;
    };
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Canvas not supported");

  let width = img.width;
  let height = img.height;
  if (width > maxWidth) {
    const scale = maxWidth / width;
    width = maxWidth;
    height = height * scale;
  }

  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(img, 0, 0, width, height);

  let quality = 0.9;
  let base64 = canvas.toDataURL("image/jpeg", quality);
  while (base64.length / 1024 > maxSizeKB && quality > 0.1) {
    quality -= 0.05;
    base64 = canvas.toDataURL("image/jpeg", quality);
  }

  return {
    base64,
    sizeKB: Math.round(base64.length / 1024),
  };
};

export function fileToBase64(file: File): Promise<string | ArrayBuffer | null> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    if (file) {
      reader.readAsDataURL(file);

      reader.onload = () => {
        if (typeof reader.result === "string") {
          const base64 = reader.result;
          resolve(base64);
        } else {
          reject(new Error("FileReader result is not a string."));
        }
      };

      reader.onerror = (error) => reject(error);
    } else {
      resolve("");
    }
  });
}
export function getCurrentLocation(): Promise<{
  lat: number;
  lng: number;
}> {
  return new Promise((resolve, reject) => {
    if (!navigator.geolocation) {
      reject(new Error("Geolocation is not supported by your browser."));
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        resolve({ lat: latitude, lng: longitude });
      },
      (error) => {
        reject(new Error(`Geolocation error: ${error.message}`));
      },
      {
        enableHighAccuracy: true,
        timeout: 10000,
        maximumAge: 0,
      }
    );
  });
}

export function getUUID(): string {
  let id = Cookies.get(COOKIE.DEVICE_UIID);
  if (!id) {
    id = uuid();
    Cookies.set(COOKIE.DEVICE_UIID, id, {
      expires: XUIID_TIMEOUT, // days
      secure: true,
    });
  }
  return id;
}

export function getFingerprint() {
  const fingerprintData = Cookies.get(COOKIE.DEVICE_APPS);

  if (!fingerprintData) {
    const member_apps: any = {};
    Fingerprint2.get({}, async (components) => {
      APP_MEMBER_KEY.forEach((app_key) => {
        member_apps[app_key] = components.find(
          (item) => item.key == app_key
        )?.value;
      });
      member_apps["deviceUuid"] = getUUID();
      member_apps["devicePlatformType"] = getPlatformDeviceType(
        member_apps["userAgent"]
      );
      member_apps["systemName"] = getOperatingSystem();
      Cookies.set(
        COOKIE.DEVICE_APPS,
        encryptDataNetwork(JSON.stringify(member_apps)),
        {
          expires: XDEVICE_APP_TIMEOUT, // days
          secure: true,
        }
      );
    });
  }

  return fingerprintData;
}
